// Module
var code = `<div class="padding_y_5 flexible_container flex_center_aligned">
    <label for="repeated-instances-repetitions" data-bind="text: translated('Number of repetitions') + ':'" class="padding_r_5"></label>
    <input type="number" class="width_50" min="1" max="50" id="repeated-instances-repetitions" data-bind="css: {invalid_data: numberOfRepetitions.isInvalid},
                      valueAsNumber: numberOfRepetitions">
    <div class="error" data-bind="text: numberOfRepetitions.errorMessage"></div>
</div>
<div class="padding_y_5 flexible_container flex_center_aligned">
    <label for="repeated-instances-options" class="padding_r_5" data-bind="text: translated('Repeat') + ':'"></label>
    <select class="width_100" id="repeated-instances-options" data-bind="value: repeatInterval,
                       options: [
                           {id: 'daily', name: translated('Daily')},
                           {id: 'weekly', name: translated('Weekly')},
                           {id: 'custom', name: translated('Custom')},
                       ],
                       optionsValue: 'id',
                       optionsText: 'name'"></select>
</div>
<div class="padding_t_5" data-bind="visible: repeatInterval() === 'daily'">
    <div class="padding_y_5 flexible_container flex_center_aligned">
        <input type="radio" id="repeated-instances-daily" value="every_day" data-bind="checked: dailyChoice">
        <label for="repeated-instances-daily" data-bind="text: translated('Every day')" class="padding_x_5"></label>
    </div>
    <div class="padding_y_5 flexible_container flex_center_aligned">
        <input type="radio" id="repeated-instances-every-weeekday" value="every_weekday" data-bind="checked: dailyChoice">
        <label for="repeated-instances-every-weekday" data-bind="text: translated('Every weekday')" class="padding_x_5"></label>
    </div>
    <div class="padding_y_5 flexible_container flex_center_aligned">
        <input type="radio" id="repeated-instances-every-x-day" value="every_x_day" data-bind="checked: dailyChoice">
        <label for="repeated-instances-every-x-day" data-bind="text: translated('Every')" class="padding_x_5"></label>
        <input type="number" id="repeated-instances-every-day" class="width_50" data-bind="css: {invalid_data: daysOffset.isInvalid},
                          valueAsNumber: daysOffset,
                          disable: dailyChoice() !== 'every_x_day'">
        <label data-bind="text: translated('days')" for="repeated-instances-every-day" class="padding_x_5"></label>
    </div>
</div>
<div class="padding_t_5" data-bind="visible: repeatInterval() === 'weekly'">
    <div class="padding_y_5 flexible_container flex_center_aligned">
        <input type="radio" id="repeated-instances-every-week" value="every_week" data-bind="checked: weeklyChoice">

        <label for="repeated-instances-every-week" data-bind="text: translated('Every week')" class="padding_x_5"></label>
    </div>
    <div class="padding_y_5 flexible_container flex_center_aligned">
        <input type="radio" id="repeated-instances-every-x-week" value="every_x_week" data-bind="checked: weeklyChoice">
        <label for="repeated-instances-every-x-week" data-bind="text: translated('Every')" class="padding_x_5"></label>
        <input type="number" class="width_50" id="repeated-instances-weeks" data-bind="css: {invalid_data: weeksOffset.isInvalid},
                          valueAsNumber: weeksOffset,
                          disable: weeklyChoice() !== 'every_x_week'">
        <label data-bind="text: translated('weeks')" for="repeated-instances-weeks" class="padding_x_5"></label>
    </div>
</div>
<div class="padding_t_10" data-bind="visible: repetitionDates().length">
    <span class="italic" data-bind="text: repetitionDatesDescription.replace('%s', repetitionDates().length) + ':'"></span>
    <div class="repetition_dates_container tw:pt-2 tw:overflow-auto tw:max-h-36">
        <!-- ko foreach: repetitionDates -->
        <ko-calendar-popup params="value: \$rawData,
                                   valueUpdate: 'input',
                                   class: 'width_100',
                                   name: \$parent.repetitionDatesNameAttribute,
                                   css: {invalid_data: \$rawData.isInvalid},
                                   options: {maxDate: \$parent.maxDate}"></ko-calendar-popup>
        <!-- /ko -->
    </div>
</div>
`;
// Exports
export default code;